"use client";

import React from "react";
import { Plus } from "lucide-react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface CreateBookCardProps {
  onClick?: () => void;
  href?: string;
}

export function CreateBookCard({ onClick, href }: CreateBookCardProps) {
  const content = (
    <Card 
      className={cn(
        "group h-full flex flex-col items-center justify-center p-6 transition-all duration-300 min-h-[160px]",
        "bg-transparent border-2 border-dashed border-border/60 hover:border-primary/50 hover:bg-primary/5",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/60 cursor-pointer"
      )}
    >
      <div className="flex flex-col items-center gap-3 text-center">
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-muted group-hover:bg-primary/10 text-muted-foreground group-hover:text-primary transition-colors">
          <Plus className="w-6 h-6" />
        </div>
        <div>
          <h3 className="font-medium text-foreground group-hover:text-primary transition-colors">
            Gerar Novo Livro
          </h3>
          <p className="text-sm text-muted-foreground mt-1">
            Crie uma nova obra com IA
          </p>
        </div>
      </div>
    </Card>
  );

  if (href) {
    return (
      <a 
        href={href} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="block h-full outline-none"
      >
        {content}
      </a>
    );
  }

  return (
    <div 
      onClick={onClick} 
      role="button" 
      tabIndex={0} 
      className="h-full outline-none"
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      {content}
    </div>
  );
}